/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {
  defaultCreateAppData,
  ICreateAppData,
} from '../../../../_metronic/partials/modals/create-app-stepper/IAppModels'
import {StepperComponent} from '../../../../_metronic/assets/ts/components'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import Swal from 'sweetalert2'

import {create_tenant, get_Subdivions} from '../Tenant_API'
// import AddTenantStep5 from '../../property/AddTenantStep5'
import {Link, useNavigate} from 'react-router-dom'
import AddTenantStep1 from '../AddTenant/AddTenantStep1'
import AddTenantStep3 from '../AddTenant/AddTenantStep3'
import AddTenantStep4 from '../AddTenant/AddTenantStep4'
import AddTenantStep5 from '../AddTenant/AddTenantStep5'
import AddResTenant from '../AddTenant/AddResTenant'
import AddComTenant from '../AddTenant/AddComTenant'

type PropsDataType = {
  getProperty: Promise<void>
  show: boolean
  handleClose: () => void
}
interface subdivisionsDataType {
  property_sub_unit_uuid: string
  property_unit_description: string
  property_unit_max_tenants: number
  property_unit_name: string
  property_unit_rent: string
}
const modalsRoot = document.getElementById('root-modals') || document.body

const UpcomingTenants = ({
  property_uuid,
  show,
  handleClose,
  getTenantsList,
  subDivisions,
  tenantAPIData,
  additionalData,
  tenatlist,
  getTenants,
}: any) => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [tenants1, setTenats1] = useState<Boolean>(false)
  const [selectedTenant, setSelectedTenant] = useState<any>(null)
  const [AdditionalData, setAdditionalData] = useState<any>(null)

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const initialValues = {
    tenant_name: '',
    tenant_email_id: '',
    tenant_contact_number: '',
    property_sub_unit_uuid: '',
    property_rent_rate: '',
    security_deposit: '',
    property_rent_due_date: '',
    rental_agreement_date: '',
    tenancy_commencement_date: '',
    tenancy_expiration_date: '',
  }

  const validationSchema = Yup.object({
    tenant_name: Yup.string()
      .matches(/^[A-Za-z0-9\s]*$/, 'Only alphanumeric characters and spaces are allowed')
      .min(3, 'Minimum 3 characters required')
      .max(50, 'Maximum 50 characters are allowed')
      .required('Tenant name is required'),
    tenant_email_id: Yup.string()
      .required('Tenant email address is required')
      .email('Wrong email format'),
    tenant_contact_number: Yup.string().required('Tenant contact number is required'),
    property_sub_unit_uuid: Yup.string().required('Room number is required'),
    property_rent_rate: Yup.number()
      .typeError('Rent amount must be a number')
      .integer('Rent amount must be an integer')
      .positive('Rent amount must be a positive number')
      .min(0, 'Rent amount must be greater than or equal to 0')
      .max(999999999999999, 'Rent amount must have at most 15 digits')
      .required('Rent amount is required'),
    security_deposit: Yup.number()
      .typeError('Security deposit must be a number')
      .integer('Security deposit must be an integer')
      .positive('Security deposit must be a positive number')
      .min(0, 'Security deposit must be greater than or equal to 0')
      .optional(),
    property_rent_due_date: Yup.string().required('Rent due date is required'),
    rental_agreement_date: Yup.date().required('Rental agreement date is required'),
    tenancy_commencement_date: Yup.date().required('Tenancy commencement date is required'),
    tenancy_expiration_date: Yup.date().required('Tenancy expiration date is required'),
  })

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      console.log('')
    },
  })

  useEffect(() => {
    if (tenantAPIData && tenantAPIData.length > 0) {
      formik.setFieldValue('tenant_name', tenantAPIData[0]?.full_name || '')
      formik.setFieldValue('tenant_email_id', tenantAPIData[0]?.email || '')
      formik.setFieldValue('tenant_contact_number', tenantAPIData[0]?.mobile_number || '')
      formik.setFieldValue('property_rent_rate', additionalData[0]?.monthlyRent || '')
      formik.setFieldValue('security_deposit', additionalData[0]?.depositAmount || '')
      formik.setFieldValue('tenancy_commencement_date', additionalData[0]?.moveInDate || '')
    }
  }, [tenantAPIData])

  const handleOnboard = (property: any) => {
    console.log('property', property)
    setSelectedTenant(property)
    setTenats1(true)
    setAdditionalData(JSON.parse(property.additional_data))
  }

  // const checkAddPropertyStep2 = () => {
  //   if (
  //     formik.values.business_name &&
  //     formik.values.business_email_id &&
  //     formik.values.business_contact_number &&
  //     !formik.errors.business_name &&
  //     !formik.errors.business_email_id &&
  //     !formik.errors.business_contact_number
  //   ) {
  //     return true
  //   } else {
  //     formik.setTouched(
  //       {
  //         business_name: true,
  //         business_email_id: true,
  //         business_contact_number: true,
  //       },
  //       true
  //     )
  //     return false
  //   }
  // }

  return (
    <>
      {createPortal(
        <Modal
          id='kt_modal_create_app'
          tabIndex={-1}
          aria-hidden='true'
          dialogClassName='modal-dialog modal-dialog-centered mw-900px'
          show={show}
          onHide={handleClose}
          onEntered={loadStepper}
          backdrop={true}
        >
          <div className='modal-header pt-5 pb-5'>
            {/* begin::Heading */}
            {tenatlist === 2 ? (
              <h2>Add Commercial Tenant</h2>
            ) : (
              <h2>Add Residential Tenant</h2>
            )}{' '}
            {/* end::Heading */}
            {/* begin::Close */}
            <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
              <i className='bi bi-x-lg' onClick={handleClose}></i>
            </div>
            {/* end::Close */}
          </div>

          <div className='modal-body p-5'>
            {/*begin::Stepper */}
            <div id='table div'>
              <div className='card mb-5 mb-xl-8'>
                <div className='card-body py-3'>
                  <div className='table-responsive'>
                    {/* begin::Table */}
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      {/* begin::Table head */}
                      {tenantAPIData?.length > 0 && (
                        <thead>
                          <tr className='fw-bold text-muted'>
                            {/* <th className='w-25px'>
                            <div className='form-check form-check-sm form-check-custom form-check-solid'>
                              <input
                                className='form-check-input'
                                type='checkbox'
                                value='1'
                                data-kt-check='true'
                                data-kt-check-target='.widget-9-check'
                              />
                            </div>
                          </th> */}
                            <th className='max-w-150px'>Name</th>
                            <th className='max-w-150px'>Email</th>
                            <th className='max-w-150px'>Contact No</th>
                            {/* <th className='max-w-150px'>Available</th>
                        <th className='max-w-200px'>Details</th>
                        <th className='max-w-100px'>Rent</th>
                        <th className='max-w-50px'>Role</th> */}
                            <th className='max-w-150px'>Actions</th>
                          </tr>
                        </thead>
                      )}
                      {/* end::Table head */}
                      {/* begin::Table body */}
                      <tbody>
                        {/* {noKYCFound ? (
                          <tr>
                            <td colSpan={5}>
                              <span className='d-flex flex-column align-items-center flex-start p-10'>
                                <img
                                  src='/media/svg/undraw/property.svg'
                                  alt='No document uploaded'
                                  className='h-200px w-200px'
                                />
                                <span className='fw-bold text-muted fs-1 text-center'>
                                  KYC is required to add property
                                </span>
                                <Link
                                  to='/KYC_Details'
                                  className='mt-6 btn btn-sm fw-bold btn-primary'
                                >
                                  Add KYC Account
                                </Link>
                              </span>
                            </td>
                          </tr>
                        ) : !noKYCFound && allKYC.length > 0 && activeKYC.length <= 0 ? (
                          <tr>
                            <td colSpan={5}>
                              <span className='d-flex flex-column align-items-center flex-start p-10'>
                                <img
                                  src='/media/svg/undraw/property.svg'
                                  alt='No document uploaded'
                                  className='h-200px w-200px'
                                />
                                <span className='fw-bold text-muted fs-1 text-center'>
                                  Your KYC is pending verification
                                </span>
                                <Link
                                  to='/KYC_Details'
                                  className='mt-6 btn btn-sm fw-bold btn-primary'
                                >
                                  Add Another KYC Account
                                </Link>
                              </span>
                            </td>
                          </tr>
                        ) :  */}
                        {tenantAPIData.length === 0 || tenantAPIData === undefined ? (
                          <tr>
                            <td colSpan={5}>
                              <span className='d-flex flex-column align-items-center flex-start p-10'>
                                <img
                                  src='/media/svg/undraw/property.svg'
                                  alt='No document uploaded'
                                  className='h-200px w-200px'
                                />
                                <span className='fw-bold text-muted fs-1 text-center'>
                                  No Leads present
                                </span>
                              </span>
                            </td>
                          </tr>
                        ) : (
                          tenantAPIData?.map((property: any, index: number) => {
                            return (
                              <tr key={index}>
                                {/* <td>
                                <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                  <input
                                    className='form-check-input widget-9-check'
                                    type='checkbox'
                                    value='1'
                                  />
                                </div>
                              </td> */}
                                <td className='max-w-150px'>
                                  <div className='d-flex align-items-center'>
                                    <div className=' me-3'>
                                      <span className='me-2'>
                                        <span className=''>{property?.full_name}</span>
                                      </span>
                                    </div>
                                    <div className='d-flex justify-content-start flex-column'>
                                      {/* <Link
                                    to={`/property/${property.property_uuid}/overview`}
                                    className='text-dark fw-bold text-hover-primary fs-6'
                                    title={
                                      property.property_title.charAt(0).toUpperCase() +
                                      property.property_title.slice(1)
                                    }
                                  >
                                    <div className='text-truncate mw-95px'>
                                      {property.property_title.charAt(0).toUpperCase() +
                                        property.property_title.slice(1)}
                                    </div>
                                  </Link> */}
                                      <span className='text-muted fw-semibold text-muted d-block fs-7 w-100'>
                                        {property.property_type_name}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td className='max-w-150px'>
                                  <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                    {`${property.email}`}
                                  </span>
                                </td>
                                <td className='max-w-100px'>
                                  <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                    {`${property.mobile_number}`}
                                  </span>
                                </td>

                                <td className='max-w-150px'>
                                  <div className='d-flex flex-shrink-0'>
                                    <button
                                      className='btn btn-sm fw-bold btn-primary'
                                      onClick={() => handleOnboard(property)}
                                    >
                                      {' '}
                                      Onboard Lead
                                    </button>
                                    {/* {property.property_account_status === 2 ? (
                                      <button
                                        onClick={() => handleUnBlock(property.property_uuid)}
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                      >
                                        <i className='bi bi-check-square fs-3' title='Unblock'></i>
                                      </button>
                                    ) : (
                                      <button
                                        onClick={() => handleBlock(property.property_uuid)}
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                      >
                                        <i className='bi bi-x-square fs-3' title='Block'></i>
                                      </button>
                                    )} */}
                                  </div>
                                </td>
                              </tr>
                            )
                          })
                        )}
                      </tbody>
                      {/* end::Table body */}
                    </table>
                    {/* end::Table */}
                  </div>
                </div>
              </div>
            </div>
            {/* end::Stepper */}
          </div>
        </Modal>,
        modalsRoot
      )}
      {tenants1 && tenatlist === 2 ? (
        <AddComTenant
          property_uuid={property_uuid}
          show={tenants1}
          handleClose={() => setTenats1(false)}
          getTenantsList={getTenantsList}
          subDivisions={subDivisions}
          additionalData={AdditionalData}
          tenantAPIData={selectedTenant}
          getTenants={getTenants}
        />
      ) : (
        <AddResTenant
          property_uuid={property_uuid}
          show={tenants1}
          handleClose={() => setTenats1(false)}
          getTenantsList={getTenantsList}
          subDivisions={subDivisions}
          additionalData={AdditionalData}
          tenantAPIData={selectedTenant}
          getTenants={getTenants}
        />
      )}
    </>
  )
}

export default UpcomingTenants
